import { defineComponent as _defineComponent } from 'vue'
import { computed } from "vue";
  import CheckMark from "@/components/ui/icons/Checkmark.vue";
  import {
    CustomizeHouseStepsEnum,
    CustomizeHouseStepsReviewQuoteEnum,
  } from "@/enums/CustomizeHouseSteps";
  import { StepTypeEnum } from "@/enums/BuilderStepType";
  import store from "@/store";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'StepperLineDesktop',
  props: {
    step: {
      type: String,
      default: "",
    },
    tabs: {
      type: Array,
      default: () => [],
    },
    stepType: {
      type: String,
      default: StepTypeEnum.CUSTOMIZE_HOUSE_STEPS,
      required: false,
    },
    skipStep: {
      type: String,
      required: false,
    },
    skipStepIndex: {
      type: Number,
      required: false,
    },
  },
  emits: ["toRequestQuoteForm", "toReturnMap"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

  const props = __props;

  const emits = __emit;

  const steppyProgress = computed(() => {
    return `${(100 / (props.tabs.length - 1)) * (stepIndex.value - 1)}%`;
  });
  const isFirstStep = computed(() => stepIndex.value === 1);
  const isLastStep = computed(() => stepIndex.value === props.tabs.length);

  const stepIndex = computed(() => {
    const enumToUse =
      props.stepType === StepTypeEnum.CUSTOMIZE_HOUSE_STEPS_REVIEW_QUOTE
        ? CustomizeHouseStepsReviewQuoteEnum
        : CustomizeHouseStepsEnum;

    return (
      Object.values(enumToUse).findIndex((item) => item === props.step) + 1
    );
  });

  const selectedQuote = computed(
    () => store.getters["builder/getSelectedSelection"]
  );

  const currentStepIndex = computed(() => {
    const currentStep = selectedQuote.value?.currentStep;

    return Object.values(CustomizeHouseStepsEnum).indexOf(currentStep);
  });

  const nextStepIndex = computed(() => {
    let currentStepIndexVal = currentStepIndex.value;

    if (currentStep.value === props?.skipStep) {
      currentStepIndexVal++;
    }

    return (
      (currentStepIndexVal + 1) % Object.values(CustomizeHouseStepsEnum).length
    );
  });

  const prevStepIndex = computed(() => {
    return (
      (currentStepIndex.value -
        1 +
        Object.values(CustomizeHouseStepsEnum).length) %
      Object.values(CustomizeHouseStepsEnum).length
    );
  });

  const currentStep = computed(() => {
    return Object.values(CustomizeHouseStepsEnum)[currentStepIndex.value];
  });

  const nextStepText = computed(() => {
    let nextStep: string;

    if (currentStep.value === CustomizeHouseStepsEnum.CONFIRMATION) {
      nextStep = "Confirm Selections";
    } else {
      nextStep = Object.values(CustomizeHouseStepsEnum)[nextStepIndex.value];
    }

    if (nextStep === props.skipStep) {
      nextStep = Object.values(CustomizeHouseStepsEnum)[
        nextStepIndex.value + 1
      ];
    }

    return nextStep;
  });

  const prevStepText = computed(() => {
    let prevStep = Object.values(CustomizeHouseStepsEnum)[prevStepIndex.value];

    if (prevStep === props.skipStep) {
      return Object.values(CustomizeHouseStepsEnum)[prevStepIndex.value - 1];
    }

    return prevStep;
  });

  const isBuilderCompleted = computed(() => {
    const builder = selectedQuote.value.builder;

    return Object.values(builder).every((field) => field !== "");
  });

  const isHouseDesignCompleted = computed(() => {
    const house = selectedQuote.value.house;

    return Object.values(house).every((field) => field !== "");
  });

  const isFacadeCompleted = computed(() => {
    const facade = selectedQuote.value.facade;

    return Object.values(facade).every((field) => field !== "");
  });

  const isNextStepEnabled = computed(() => {
    switch (currentStep.value) {
      case CustomizeHouseStepsEnum.BUILDER:
        return isBuilderCompleted.value;
      case CustomizeHouseStepsEnum.HOUSE_DESIGN:
        return isHouseDesignCompleted.value;
      case CustomizeHouseStepsEnum.EXTERIOR:
        return isFacadeCompleted.value;
      default:
        return true;
    }
  });

  const nextStepTextButton = computed(() =>
    currentStep.value === CustomizeHouseStepsEnum.CONFIRMATION
      ? "Get Prices"
      : "Next"
  );

  function onSelectNext() {
    if (currentStep.value === CustomizeHouseStepsEnum.CONFIRMATION) {
      emits("toRequestQuoteForm");
    } else {
      store.commit("builder/updateUserSelection", {
        ...selectedQuote.value,
        currentStep: nextStepText.value,
      });
    }
  }
  function onSelectPrev() {
    if (currentStep.value === CustomizeHouseStepsEnum.LOT) {
      emits("toReturnMap");
    } else {
      store.commit("builder/updateUserSelection", {
        ...selectedQuote.value,
        currentStep: prevStepText.value,
      });
    }
  }

  function getStepItemClass(index: number) {
    return {
      current: stepIndex.value === index + 1,
      success: stepIndex.value > index + 1,
      hidden: props.skipStepIndex === index,
    };
  }

const __returned__ = { props, emits, steppyProgress, isFirstStep, isLastStep, stepIndex, selectedQuote, currentStepIndex, nextStepIndex, prevStepIndex, currentStep, nextStepText, prevStepText, isBuilderCompleted, isHouseDesignCompleted, isFacadeCompleted, isNextStepEnabled, nextStepTextButton, onSelectNext, onSelectPrev, getStepItemClass, computed, CheckMark, get CustomizeHouseStepsEnum() { return CustomizeHouseStepsEnum }, get CustomizeHouseStepsReviewQuoteEnum() { return CustomizeHouseStepsReviewQuoteEnum }, get StepTypeEnum() { return StepTypeEnum }, get store() { return store } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})